export default __webpack_public_path__ + "static/media/cropsieTwitter-600x314.04720af5.jpg";